import { ViewChild } from '@angular/core'
import { APP_INJECTOR } from 'app.module'
import { ModalDirective } from 'ng2-bootstrap/src/modal'
import { YandexMetrikaService } from 'pages/admin/yandex-metrika.service'
import { Subscription } from 'rxjs/Subscription'

import { BaseFormComponent } from './base-form.component'


export abstract class BaseModalFormComponent extends BaseFormComponent {
  @ViewChild('modal') protected modal: ModalDirective

  protected modalShowSubscription: Subscription
  protected modalShownSubscription: Subscription
  protected modalHideSubscription: Subscription
  protected modalHiddenSubscription: Subscription

  protected _ym: YandexMetrikaService

  constructor() {
    super()
    this._ym = APP_INJECTOR.get(YandexMetrikaService)
  }

  ngOnInit() {
    super.ngOnInit()

    this.modalShowSubscription   = this.modal.onShow.subscribe(event => this.onModalShow())
    this.modalShownSubscription  = this.modal.onShown.subscribe(event => this.onModalShown())
    this.modalHideSubscription   = this.modal.onHide.subscribe(event => this.onModalHide())
    this.modalHiddenSubscription = this.modal.onHidden.subscribe(event => this.modalHiddenWrapper())
  }

  ngOnDestroy() {
    super.ngOnDestroy()

    this.modalShowSubscription.unsubscribe()
    this.modalShownSubscription.unsubscribe()
    this.modalHideSubscription.unsubscribe()
    this.modalHiddenSubscription.unsubscribe()
  }

  abstract showNew(params?: Object)

  abstract showEdit(id: number|any)

  hide() {
    this.modal.hide()
  }

  protected onModalShow() {
    const email = this.currentUser() ? this.currentUser().email : 'unknown'
    this._ym.reachGoal('open_modal', { user: email, modal: this.constructor.name })
  }

  protected onModalShown() {}

  protected onModalHide() {}

  protected onModalHidden() {
    this.form = null
    this.loading = false
  }

  private modalHiddenWrapper(){
    setTimeout(() => {
      let modlaBackDrops = document.querySelectorAll("bs-modal-backdrop")
      if (modlaBackDrops.length > 0) {
        let body = document.querySelector("body")
        body.classList.add("modal-open")
      }
    }, 0)
    this.onModalHidden()
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/base-modal-form.component.ts